/**
 * @msg: 1、用户名只能为中文
 */
export const validateUserName = (rule, value, callback) => {
  const reg =/^[\u4E00-\u9FA5]+$/
  if(value==''||value==undefined||value==null){
    callback()
  }else {
    if ((!reg.test(value)) && value != '') {
      callback(new Error('只能为中文'));
    } else {
      callback()
    }
  }
}

/**
 * @msg: 2、是否手机号码
 */
export const validatePhone = (rule, value, callback) => {
  const reg =/^1[34578]\d{9}$/
  if(value==''||value==undefined||value==null){
    callback()
  }else {
    if ((!reg.test(value)) && value != '') {
      callback(new Error('请输入正确的手机号码'))
    } else {
      callback()
    }
  }
}

/**
 * @msg: 3、是否邮箱
 */
export const validateEMail = (rule, value, callback) => {
  const reg =/^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/
  if(value==''||value==undefined||value==null){
    callback()
  }else{
    if (!reg.test(value)){
      callback(new Error('请输入正确的邮箱'))
    } else {
      callback()
    }
  }
}

/**
 * @msg: 4、是否身份证号码
 */
export const validateIdNo = (rule, value, callback) => {
  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  if(value==''||value==undefined||value==null){
    callback()
  }else {
    if ((!reg.test(value)) && value != '') {
      callback(new Error('请输入正确的身份证号码'))
    } else {
      callback()
    }
  }
}

/**
 * @msg: 5、是数字
 */
export const validateNum = (rule, value, callback) => {
  const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/
  if(value==''||value==undefined||value==null){
    callback()
  }else {
    if ((!reg.test(value)) && value != '') {
      callback(new Error('只能是大于0的数字'))
    } else {
      callback()
    }
  }
}